module.exports = __webpack_public_path__ + "img/success_new.ce267049.png";